import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'

const LinkComponent = props => (
  <Link href={props.href} as={props.as}>
    <LinkStyled alt={props.alt} title={props.alt}>
      {props.label}
    </LinkStyled>
  </Link>
)

export default LinkComponent

const LinkStyled = styled.a`
  font-size: 14px;
  color: #4e5657;
  &.active {
    color: #4e5657;
  }
  &:hover {
    color: #4e5657;
  }
`
